/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'camera': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<circle pid="0" cx="24" cy="26" r="2.75"/><path pid="1" d="M33.599 17h-3.41c-.013-.035-.016-.069-.031-.105l-.315-.789C29.379 14.947 27.979 14 26.732 14h-5.465c-1.247 0-2.646.947-3.11 2.105l-.315.789c-.015.036-.018.07-.031.105h-3.41A3.413 3.413 0 0 0 11 20.401v10.197A3.412 3.412 0 0 0 14.401 34h19.197A3.412 3.412 0 0 0 37 30.599V20.401A3.412 3.412 0 0 0 33.599 17zM24 31.25c-2.895 0-5.25-2.355-5.25-5.25s2.355-5.25 5.25-5.25 5.25 2.355 5.25 5.25-2.355 5.25-5.25 5.25zM34 21h-2v-1h2v1z"/><path pid="2" d="M32 20h2v1h-2z" opacity=".3"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/camera.js